import React from 'react';
import { motion } from 'framer-motion';
export function ModulesSection() {
  const modules = [{
    name: 'El Despertar de la Intuición',
    desc: 'escuchar tu verdad interna'
  }, {
    name: 'Limpieza de Creencias Limitantes',
    desc: 'raíz del bloqueo y nueva creencia coherente'
  }, {
    name: 'Relaciones y Energía',
    desc: 'límites sanos, eje y frecuencia'
  }, {
    name: 'Rutina Maestra de Manifestación',
    desc: '5 pasos diarios simples'
  }, {
    name: 'Niña Interior',
    desc: 'sanar miedo, vergüenza y autosabotaje'
  }, {
    name: 'Palabra Hablada',
    desc: 'decretos efectivos (no vacíos)'
  }, {
    name: 'Recalibración Vibracional',
    desc: 'volver a vos en minutos'
  }, {
    name: 'Manifestación y Dinero',
    desc: 'recibir, ordenar y sostener'
  }, {
    name: 'El Arte de Soltar',
    desc: 'entrega consciente sin resignación'
  }, {
    name: 'Integración de la Sombra',
    desc: 'transformar lo reprimido en poder'
  }, {
    name: 'Cuerpo y Manifestación',
    desc: 'seguridad somática para recibir'
  }, {
    name: 'Manifestación Colectiva',
    desc: 'expansión en comunidad (círculo)'
  }];
  return <section className="w-full bg-gradient-to-b from-cream-100 to-cream-200 py-20 md:py-28 px-4" data-id="element-84">
      <div className="max-w-5xl mx-auto" data-id="element-85">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="font-heading text-3xl md:text-4xl text-brown-700 text-center mb-4" data-id="element-86">
          Los 12 módulos
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-brown-500 text-center mb-12 max-w-2xl mx-auto" data-id="element-87">
          Un recorrido completo desde tu interior hasta la manifestación
          tangible
        </motion.p>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-88">
          {modules.map((module, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="flex items-start gap-4 bg-white/80 backdrop-blur-sm p-5 rounded-xl border border-gold-100 shadow-sm" data-id="element-89">
              <div className="w-10 h-10 bg-gradient-to-br from-gold-400 to-gold-600 rounded-full flex items-center justify-center flex-shrink-0 shadow-md" data-id="element-90">
                <span className="text-white font-bold text-sm" data-id="element-91">
                  {index + 1}
                </span>
              </div>
              <div data-id="element-92">
                <h3 className="font-heading text-lg text-brown-700 font-semibold" data-id="element-93">
                  {module.name}
                </h3>
                <p className="text-brown-500 text-sm" data-id="element-94">{module.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}